import { Card, Heading, sendToastMessage, ThemeToggle } from "@microbeta/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../../AuthContext";
import background from "../../assets/images/background.svg";
import { RecaptchaNotice } from "../../components/RecaptchaNotice";
import EmailInstructions from "./components/EmailInstructions";
import EnterEmailContent from "./components/EnterEmailContent";
import styles from "./request-reset-password.module.scss";

enum RequestResetPasswordSteps {
  ENTER_EMAIL = 0,
  INSTRUCTIONS = 1,
}

const RequestResetPassword = () => {
  const [step, setStep] = useState<RequestResetPasswordSteps>(
    RequestResetPasswordSteps.ENTER_EMAIL
  );
  const [email, setEmail] = useState("");
  const { requestResetPassword } = useAuthContext();
  const { t } = useTranslation();

  const handleRequestResetPassword = async () => {
    try {
      await requestResetPassword(email);
      setStep(RequestResetPasswordSteps.INSTRUCTIONS);
    } catch (e) {
      console.error(e);
      sendToastMessage(
        t("resetPassword.emailErrorTitle"),
        t("resetPassword.emailErrorDescription"),
        "error"
      );
    }
  };

  return (
    <div className={styles.container}>
      <img
        src={background}
        className={styles.backgroundImg}
        alt=""
        aria-hidden="true"
      />

      {/* Theme Toggle - positioned in top-right corner */}
      <div className={styles.themeToggleContainer}>
        <ThemeToggle size="md" />
      </div>

      <Card className={styles.card}>
        <Heading variant="medium" className={styles.title}>
          {t("resetPassword.forgotPassword")}
        </Heading>
        {step === RequestResetPasswordSteps.ENTER_EMAIL && (
          <EnterEmailContent
            email={email}
            setEmail={setEmail}
            onSendInstructions={handleRequestResetPassword}
          />
        )}
        {step === RequestResetPasswordSteps.INSTRUCTIONS && (
          <EmailInstructions
            onTryAgainPressed={() =>
              setStep(RequestResetPasswordSteps.ENTER_EMAIL)
            }
          />
        )}
        {step === RequestResetPasswordSteps.ENTER_EMAIL && <RecaptchaNotice />}
      </Card>
    </div>
  );
};

export default RequestResetPassword;
